import React, { useEffect } from "react";
import Link from "next/link";
import { DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import {
  Home,
  LayoutDashboard,
  User,
  Settings,
  Bell,
  Shield,
  AlertTriangle,
  Search,
  Users,
  CheckCircle,
  Globe,
  DollarSign,
  LayoutGrid,
} from "lucide-react";
import { getProfileUrl } from "@/utils/profileRedirects";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface NavigationItemsProps {
  userId?: string;
  isAdmin?: boolean;
  isSuperadmin?: boolean;
  isRecruiter?: boolean;
  isOnHomePage?: boolean;
  isOnDashboard?: boolean;
  isOnProfilePage?: boolean;
  isOnNotificationsPage?: boolean;
  isOnSettingsPage?: boolean;
  isOnAdminPage?: boolean;
  isOnSuperadminPage?: boolean;
  username_slug?: string | null;
}

const NavigationItems = ({
  userId,
  isAdmin = false,
  isSuperadmin = false,
  isRecruiter = false,
  isOnHomePage = false,
  isOnDashboard = false,
  isOnProfilePage = false,
  isOnNotificationsPage = false,
  isOnSettingsPage = false,
  isOnAdminPage = false,
  isOnSuperadminPage = false,
  username_slug,
}: NavigationItemsProps) => {
  // Use the utility function to get the correct profile URL
  const profileUrl = getProfileUrl(userId, username_slug);

  // Recruiters only see Hiring link, not standard navigation
  if (isRecruiter && !isSuperadmin) {
    return (
      <div className="py-1">
        <DropdownMenuItem
          asChild
          className="px-2 py-2 hover:bg-gray-100 hover:text-gray-900"
        >
          <a
            href="https://hiring.world-class.design"
            target="_self"
            className="flex items-center w-full"
          >
            <Users className="h-5 w-5 mr-3 text-gray-500" />
            <span>Hiring</span>
          </a>
        </DropdownMenuItem>
      </div>
    );
  }

  return (
    <div className="py-1">
      {!isOnHomePage && (
        <DropdownMenuItem
          asChild
          className="px-2 py-2 hover:bg-gray-100 hover:text-gray-900"
        >
          <Link
            href="https://world-class.design/"
            className="flex items-center w-full"
          >
            <Home className="h-5 w-5 mr-3 text-gray-500" />
            <span>Home</span>
          </Link>
        </DropdownMenuItem>
      )}

      {!isOnDashboard && (
        <DropdownMenuItem
          asChild
          className="px-2 py-2 hover:bg-gray-100 hover:text-gray-900"
        >
          <Link
            href="https://app.world-class.design/dashboard"
            className="flex items-center w-full"
          >
            <LayoutDashboard className="h-5 w-5 mr-3 text-gray-500" />
            <span>Dashboard</span>
          </Link>
        </DropdownMenuItem>
      )}

      {!isOnProfilePage && userId && (
        <DropdownMenuItem
          asChild
          className="px-2 py-2 hover:bg-gray-100 hover:text-gray-900"
        >
          <Link href={profileUrl} className="flex items-center w-full">
            <User className="h-5 w-5 mr-3 text-gray-500" />
            <span>Public Profile</span>
          </Link>
        </DropdownMenuItem>
      )}

      {/* {!isOnNotificationsPage && (
        <DropdownMenuItem asChild className="px-4 py-2.5 hover:bg-gray-100 hover:text-gray-900">
          <Link href="/notifications" className="flex items-center w-full">
            <Bell className="h-5 w-5 mr-3 text-gray-500" />
            <span>Notifications</span>
          </Link>
        </DropdownMenuItem>
      )} */}

      {/* {!isOnSettingsPage && (
        <DropdownMenuItem
          asChild
          className="px-4 py-2.5 hover:bg-gray-100 hover:text-gray-900"
        >
          <Link href="/settings" className="flex items-center w-full">
            <Settings className="h-5 w-5 mr-3 text-gray-500" />
            <span>Settings</span>
          </Link>
        </DropdownMenuItem>
      )} */}

      {/* {isAdmin && !isOnAdminPage && (
        <DropdownMenuItem
          asChild
          className="px-4 py-2.5 hover:bg-gray-100 hover:text-gray-900"
        >
          <Link href="/admin" className="flex items-center w-full">
            <Shield className="h-5 w-5 mr-3 text-gray-500" />
            <span>Admin</span>
          </Link>
        </DropdownMenuItem>
      )} */}

      {isSuperadmin && (
        <>
          <DropdownMenuSeparator className="my-2 bg-gray-200/80" />
          <DropdownMenuItem
            asChild
            className="px-2 py-2 hover:bg-gray-100 hover:text-gray-900"
          >
            <a
              href="https://hiring.world-class.design"
              target="_self"
              className="flex items-center w-full"
            >
              <Users className="h-5 w-5 mr-3 text-gray-500" />
              <span>Hiring</span>
            </a>
          </DropdownMenuItem>

          {!isOnSuperadminPage && (
            <DropdownMenuItem
              asChild
              className="px-2 py-2 hover:bg-gray-100 hover:text-gray-900"
            >
              <Link
                href="https://app.world-class.design/superadmin"
                className="flex items-center w-full"
              >
                <Shield className="h-5 w-5 mr-3 text-gray-500" />
                <span>Super Admin</span>
              </Link>
            </DropdownMenuItem>
          )}
        </>
      )}
    </div>
  );
};

export default NavigationItems;
